import constants from 'yola-editor/src/js/modules/publishing/constants';

export default function checkIfHostingIsSyndicated(publishingType) {
  if (publishingType && publishingType !== constants.YOLA_PARTNER_PUBLISHING_TYPE) return false;

  return true;
}
